import React from 'react';
import EntityTable from './table/EntityTable';
import LockToggle from './LockToggle';
import {withNamespaces} from 'react-i18next';

const _tableConfig = (toggleDeviceBlocking, t) => ({
  maxRows: 5,
  cols: [
    {
      header: 'Name',
      valueKey: 'name',
      method: (name) => name,
      width: '28%',
    },
    {
      header: t('deviceList.type'),
      valueKey: 'type',
      method: (type) => type,
      width: '28%',
    },
    {
      header: 'System',
      valueKey: 'os',
      method: (os) => os,
      width: '28%',
    },
    {
      header: <div style={{textAlign: 'center'}}>{t('deviceList.locked')}</div>,
      valueKey: '*',
      method: (device) => <LockToggle locked={!device.active} toggleLock={() => toggleDeviceBlocking(device)} />,
      width: '16%',
    },
  ],
});

const Table = ({devices, toggleDeviceBlocking, t}) => {
  const tableConfig = _tableConfig(toggleDeviceBlocking, t);

  return <EntityTable tableConfig={tableConfig} data={devices} msg={t('deviceList.deviceRegistration')} />;
};

export default withNamespaces()(Table);



// WEBPACK FOOTER //
// ./src/components/DeviceList.js